<template>
  <div class="fs-5">
    <div class="product-grid my-5 py-3 mb-0">
      <div class="product-sort d-none d-lg-flex mb-4 pb-2">
        <SortingBrads v-if="totalProds > 0" />
        <div class="product-sort-columns-wrapper ms-3" v-if="totalProds > 0">
          <span>{{ $t("view_as") }}</span>
          <div class="product-sort-columns">
            <div @click.prevent="handleViewAsChange(2)" :class="{ 'selected-columns': this.viewAsCheck === 2 }">
              <span></span>
              <span></span>
            </div>
            <div @click.prevent="handleViewAsChange(3)" :class="{ 'selected-columns': this.viewAsCheck === 3 }">
              <span></span>
              <span></span>
              <span></span>
            </div>
            <div @click.prevent="handleViewAsChange(4)" :class="{ 'selected-columns': this.viewAsCheck === 4 }">
              <span></span>
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>
        </div>
        <div class="dropdown ms-3" v-if="totalProds > 0">
          <button class="btn btn-secondary dropdown-toggle fw-normal" type="button" data-toggle="dropdown"
            aria-expanded="false">
            {{ $t("show") }} <strong class="d-inline-block ">{{ prodsPerPage }}</strong> {{ $t("per_page") }}
          </button>
          <ul class="dropdown-menu">
            <li><span class="dropdown-item" @click.prevent="changePerPage(12)">12</span></li>
            <li><span class="dropdown-item" @click.prevent="changePerPage(24)">24</span></li>
            <li><span class="dropdown-item" @click.prevent="changePerPage(48)">48</span></li>
            <li><span class="dropdown-item" @click.prevent="changePerPage(72)">72</span></li>
            <li><span class="dropdown-item" @click.prevent="changePerPage(84)">84</span></li>
          </ul>
        </div>
      </div>
      <div class="d-flex justify-content-between align-items-center pagetext-button" v-if="totalProds > 0">
        <a @click.prevent="openMobileFilter()" class="d-lg-none text-decoration-none" data-toggle="offcanvas"
          href="#product-filter" role="button" aria-controls="product-filter">
          <ClientOnly><i class="fa-solid fa-sliders text-secondary fs-5 me-2"></i></ClientOnly> {{ $t("filter_sort") }}
        </a>
        <p class="d-none d-lg-block fs-6 mb-0">{{ $t("articles") }} {{ currentPage }} {{ $t("to") }} {{
          Math.ceil(totalProds / prodsPerPage) }} {{ $t("by") }} {{ totalProds }} in {{ $t("total") }}</p>
        <b-pagination :total-rows="totalProds" :per-page="prodsPerPage" :value="currentPage" @change="changePage"
          class="cst-pagination" aria-controls="cat-item" align="right" :hide-goto-end-buttons="true">
          <template #page="{ page }">
            <b-link class="page-link" :to="goToPage(page)">
              {{ page }}
            </b-link>
          </template>
        </b-pagination>
      </div>
      <div class="pro-loader" v-if="isLoading">
        <div class="reverse-spinner"></div>
      </div>
      <div v-else-if="totalProds === 0">{{ $t("no_products_found") }}</div>
      <!-- <div :class="{
        'grid-row row row-cols-2 row-cols-md-3': true,
        'row-cols-xl-2 view-as-2': this.viewAsCount === 2,
        'row-cols-xl-3 view-as-3': this.viewAsCount === 3,
        'row-cols-xl-4 view-as-4': this.viewAsCount === 4
      }">
        <div class="col category-product-card" v-for="product of lists" :key="product.id">
          <ProductCard :product="product" :viewType="paginationConf.isGrid ? 'grid-view' : 'list-view'" />
        </div>
      </div> -->
      <b-pagination :total-rows="totalProds" :per-page="prodsPerPage" :value="currentPage" @change="changePage"
        class="cst-pagination bottom-sec-pagination" aria-controls="cat-item" align="center" :hide-goto-end-buttons="true"
        v-if="totalProds > 0">
        <template #page="{ page }">
          <b-link class="page-link" :to="goToPage(page)">
            {{ page }}
          </b-link>
        </template>
      </b-pagination>
    </div>
  </div>
</template>

<script>
import config from "@config";
import { mapActions } from "vuex";
import { mapGetters } from "vuex";
import { isMobile } from "mobile-device-detect";
import ClientOnly from "vue-client-only";
import SortingBrads from "@/esf_antarctica_lederhosenland/core/components/brands/SortingBrads.vue";
// import ProductCard from "@/esf_antarctica_lederhosenland/core/components/category-product/ProductCard.vue";

export default {
  name: "FilteredProducts",
  components: {
    SortingBrads,
    // ProductCard,
    ClientOnly
  },
   props: {
    viewAsCheck: {
      type: Number,
      required: true

    }
  },

  data() {
    return {
      paginationConf: {
        isGrid: true,

        currentPageNr: 1,
        totalProducts: 0,
        perPage: 12,
      },
    };
  },
  async mounted() {
    const { page, "page-size": pageSize } = this.$route.query;


    if (page) {
      this.$store.commit("product/setCurrentPage", parseInt(page));
    } else {
      this.$store.commit("product/setCurrentPage", 1);
    }

    const perPage = pageSize ? parseInt(pageSize) : 12;
    this.$store.commit("product/setProductsPerPage", perPage);

    const path = "/" + this.category.url_path;
    const query = { ...this.$route.query };
    if (perPage != config.products?.perPage) query["page-size"] = perPage;
    else delete query["page-size"];
    this.$router.replace({ path, query });

    await this.$store.dispatch("product/getProductByBrand");
  },

  computed: {
    ...mapGetters({
      getMobileCategoryFilterShow: "mobileRes/getMobileCategoryFilterShow",
    }),
    category() {
      return this.$store.getters["category/getCurrentCategory"];
    },
    isLoading() {
      return this.$store.getters["category/getLoadProducts"];
    },
    showProducts() {
      return this.$store.getters["category/getShowProducts"];
    },
    totalProducts() {
      return this.$store.getters["category/getShowProducts"].length;
    },
    currentPage() {
      return this.$store.getters["product/getBrandDetailCurrentPage"];
    },
    totalPages() {
      return this.$store.getters["category/getTotalPages"];
    },
    prodsPerPage() {
      return this.$store.getters["product/getProductsPerPage"] || 12;
    },
    totalProds() {
      return this.$store.getters["product/getBrandProductsTotalCount"] || 0;
    },
    lists() {
      if (this.$store.getters["category/getShowProducts"].length === 0) {
        return [];
      }

      const items = this.$store.getters["category/getShowProducts"];

      const filterdInStock = items.filter(
        (item) => item.stock_status == "IN_STOCK"
      );
      const outOfStock = items.filter(
        (item) => item.stock_status != "IN_STOCK"
      );

      const newProducts = [...filterdInStock, ...outOfStock];
      return newProducts;
    },
    isMobileScreen() {
      return isMobile;
    },
    priceFilterMin() {
      return this.$store.getters["category/getPriceFilterMin"];
    },
    priceFilterMax() {
      return this.$store.getters["category/getPriceFilterMax"];
    },
  },
  methods: {

     handleViewAsChange(viewMode) {
      this.$emit('update:viewAsCheck', viewMode); 
    },
    ...mapActions({
      changeMobileCategoryFilterShow:
        "mobileRes/changeMobileCategoryFilterShow",
    }),
    changePage(pageNo) {


      const { path } = this.$route;
      const query = { ...this.$route.query };

      if (pageNo != 1) query["page"] = pageNo;
      else delete query["page"];

      this.$router.replace({ path, query });
      this.$store.commit("product/setCurrentPage", pageNo);
      this.$store.dispatch("product/getProductByBrand");

    },
    goToPage(page) {
      const { path } = this.$route;
      const query = { ...this.$route.query };

      if (page != 1) query["page"] = page;
      else delete query["page"];

      return { path, query };
    },
    changePerPage(event) {
      const perPage = +event;
      const { path } = this.$route;
      const query = { ...this.$route.query };

      const pageSize = config.products?.perPage;

      if (perPage != pageSize) query["page-size"] = perPage;
      else delete query["page-size"];
      delete query["page"];

      this.$router.replace({ path, query });
      this.$store.commit("product/setProductsPerPage", perPage);
    },
    backToTop() {
      window.smoothscroll();
      this.$emit("scrolled");
    },
    viewAs(i) {
      this.viewAsCheck = i;
    },
    openMobileFilter() {
      const productFilterAside = document.getElementById('product-filter');
      if (productFilterAside && productFilterAside.classList) {
        productFilterAside.classList.add("show");
      }
    }
  },
  watch: {
    // currentPage(page) {
    //   const { path } = this.$route;
    //   const query = { ...this.$route.query, page };
    //   this.$router.replace({ path, query });
    // },
  },
};
</script>

<style lang="scss" scoped></style>
